import React, {Component} from 'react';
import SelectButton from '../../components/icon/SelectButton';

class ProductsNewCustom extends Component {
    constructor(props){
        super(props);

        this.handleOnClick = this.handleOnClick.bind(this);
        this.itemsSelected = 0;

        this.state = {
            customSectionSelected: !this.props.notSelected,
            makeupRemoverSelected:false,
            cleanserSelected:false,
            tonerSelected:false,
            moisturizerSelected:false,
            moisturizerSPFSelected:false,
            serumSelected:false,
            treatmentSelected:false,
            eyeCreamSelected:false,
            exfoliatorSelected:false,
            maskSelected:false,
            fullRegimenSelected:false,
            notSureSelected:false,
            supplementSelected: false,
        };
    }

    // componentDidUpdate(prevProps) {
    //     if (prevProps.notSelected !== this.props.notSelected) {
    //         this.setState({
    //             customSectionSelected: prevProps.notSelected, 
    //             makeupRemoverSelected:false,
    //             cleanserSelected:false,
    //             tonerSelected:false,
    //             moisturizerSelected:false,
    //             moisturizerSPFSelected:false,
    //             serumSelected:false,
    //             treatmentSelected:false,
    //             eyeCreamSelected:false,
    //             exfoliatorSelected:false,
    //             maskSelected:false,
    //             fullRegimenSelected:false,
    //             notSureSelected:false,
    //             supplementSelected: false 
    //         });
    //     }
    // }

    componentWillReceiveProps(prevProps){
       var arrayData = prevProps.productIndices;
       var product = [1, 2, 3, 4, 5, 6, 7, 8, 11, 12, 15];
       var type = true;
       product.forEach(element => {
            if( arrayData.indexOf(element) == -1){
                type = false;
            }
        });
       if(type){
        this.setState({
            makeupRemoverSelected:true,
            cleanserSelected:true,
            tonerSelected:true,
            moisturizerSelected:true,
            moisturizerSPFSelected:true,
            serumSelected:true,
            treatmentSelected:true,
            eyeCreamSelected:true,
            exfoliatorSelected:true,
            maskSelected:true,
            fullRegimenSelected:true,
            notSureSelected:true,
            supplementSelected: true 
        });
       }
       if(prevProps.notSelected != this.state.customSectionSelected){
           this.setState({
               customSectionSelected:!this.props.notSelected
           });
       }

    }



    handleOnClick(e, target) {
        if (target === "makeupRemoverSelected") {
            let selected = this.state.makeupRemoverSelected;

            this.setState({
                makeupRemoverSelected: !selected
            });

            if (!selected) {
                this.itemsSelected++;
                this.props.addItem({ index: 11, value: "Makeup Remover" });
            } else {
                this.itemsSelected--;
                this.props.removeItem({ index: 11, value: "Makeup Remover" });
            }
        }
        if (target === "cleanserSelected") {
            var selected = this.state.cleanserSelected;
            this.setState({
                cleanserSelected: !selected
            });
            if (!selected) {
                this.itemsSelected++;
                this.props.addItem({ index: 1, value: "Cleanser" });
            } else {
                this.itemsSelected--;
                this.props.removeItem({ index: 1, value: "Cleanser" });
            }
        }

        if (target === "tonerSelected") {
            var selected = this.state.tonerSelected;
            this.setState({
                tonerSelected: !selected
            });

            if (!selected) {
                this.itemsSelected++;
                this.props.addItem({ index: 2, value: "Toner" });
            } else {
                this.itemsSelected--;
                this.props.removeItem({ index: 2, value: "Toner" });
            }
        }

        if (target === "moisturizerSelected") {
            let selected = this.state.moisturizerSelected;

            this.setState({
                moisturizerSelected: !selected
            });

            if (!selected) {
                this.itemsSelected++;
                this.props.addItem({ index: 3, value: "Moisturizer" });
            } else {
                this.itemsSelected--;
                this.props.removeItem({ index: 3, value: "Moisturizer" });
            }
        }

        if (target === "moisturizerSPFSelected") {
            let selected = this.state.moisturizerSPFSelected;

            this.setState({
                moisturizerSPFSelected: !selected
            });

            if (!selected) {
                this.itemsSelected++;
                this.props.addItem({ index: 4, value: "SPF" });
            } else {
                this.itemsSelected--;
                this.props.removeItem({ index: 4, value: "SPF" });
            }
        }

        if (target === "serumSelected") {
            let selected = this.state.serumSelected;

            this.setState({
                serumSelected: !selected
            });

            if (!selected) {
                this.itemsSelected++;
                this.props.addItem({ index: 5, value: "Serum" });
            } else {
                this.itemsSelected--;
                this.props.removeItem({ index: 5, value: "Serum" });
            }
        }

        if (target === "treatmentSelected") {
            let selected = this.state.treatmentSelected;

            this.setState({
                treatmentSelected: !selected
            });

            if (!selected) {
                this.itemsSelected++;
                this.props.addItem({ index: 12, value: "Treatment" });
            } else {
                this.itemsSelected--;
                this.props.removeItem({ index: 12, value: "Treatment" });
            }
        }

        if (target === "eyeCreamSelected") {
            let selected = this.state.eyeCreamSelected;
            this.setState({
                eyeCreamSelected: !selected
            });
            if (!selected) {
                this.itemsSelected++;
                this.props.addItem({ index: 6, value: "Eye Cream" });
            } else {
                this.itemsSelected--;
                this.props.removeItem({ index: 6, value: "Eye Cream" });
            }
        }

        if (target === "exfoliatorSelected") {
            let selected = this.state.exfoliatorSelected;

            this.setState({
                exfoliatorSelected: !selected
            });

            if (!selected) {
                this.itemsSelected++;
                this.props.addItem({ index: 7, value: "Exfoliator" });
            } else {
                this.itemsSelected--;
                this.props.removeItem({ index: 7, value: "Exfoliator" });
            }
        }

        if (target === "maskSelected") {
            let selected = this.state.maskSelected;

            this.setState({
                maskSelected: !selected
            });

            if (!selected) {
                this.itemsSelected++;
                this.props.addItem({ index: 8, value: "Mask" });
            } else {
                this.itemsSelected--;
                this.props.removeItem({ index: 8, value: "Mask" });
            }
        }

        if (target === "supplementSelected") {
            let selected = this.state.supplementSelected;

            this.setState({
                supplementSelected: !selected
            });

            if (!selected) {
                this.itemsSelected++;
                this.props.addItem({ index: 15, value: "Supplement" });
            } else {
                this.itemsSelected--;
                this.props.removeItem({ index: 15, value: "Supplement" });
            }
        }
    }

    handleClassName(target) {
        let bubbleClassName = "multiselect-component__selectable"
        if ((target !== "notSureSelected") && (target !== "fullRegimenSelected")) {
            if (this.state.notSureSelected || this.state.fullRegimenSelected) bubbleClassName = bubbleClassName + " grayed-out";
            else if(this.state[target]) bubbleClassName = bubbleClassName + " selected"; 
        } else {
            if (this.itemsSelected > 0) bubbleClassName = bubbleClassName + " grayed-out";
            else if ((target === "notSureSelected") && this.state.fullRegimenSelected) bubbleClassName = bubbleClassName + " grayed-out";
            else if ((target === "fullRegimenSelected") && this.state.notSureSelected) bubbleClassName = bubbleClassName + " grayed-out";
            else if (this.state[target]) bubbleClassName = bubbleClassName + " selected"; 
        }
        return bubbleClassName;
    }

  

    render() {
        const productArray = [
            { index: 11, value: "Makeup Remover", target: "makeupRemoverSelected" },
            { index: 1, value: "Cleanser", target: "cleanserSelected" },
            { index: 2, value: "Toner", target: "tonerSelected" },
            { index: 3, value: "Moisturizer", target: "moisturizerSelected" },
            { index: 4, value: "SPF", target: "moisturizerSPFSelected" },
            { index: 5, value: "Serum", target: "serumSelected" },
            { index: 12, value: "Treatment", target: "treatmentSelected" },
            { index: 6, value: "Eye Cream", target: "eyeCreamSelected" },
            { index: 8, value: "Mask", target: "maskSelected" },
            { index: 7, value: "Exfoliator", target: "exfoliatorSelected" },
            // { index: 15, value: "Supplement", target: "supplementSelected" }
        ];

        
        
        const productButtons = productArray.map(product => {
            
            return(
                 <div key={ product.index } className="option" onClick={(e) => this.handleOnClick(e, product.target)}>
                    <SelectButton name={ product.value } selectable={ true }
                        // selected={ false } 
                        id={ "productButton-" + product.index }
                        selected={ this.props.productIndices && this.props.productIndices.indexOf(product.index) > -1 }
                        customSelected={ this.state.customSectionSelected  }
                    />
                </div>
            );
        });

        return (
            <div className="custom-routine-products">
                { productButtons }
            </div>
        );
    }
    
}

export default ProductsNewCustom;



// WEBPACK FOOTER //
// ./src/views/onboarding/ProductsNewCustom.js